import React from 'react';
import { withRouter } from 'next/router';
import { TheScoreSmallArticleContentCardItem } from 'sports-react';

interface Props {
  imageAltText?: string;
  imageURL?: string;
  publishedAt: string;
  text: string;
  onClick?: any;
  webUri: string;
  styleOverrides?: any;
  leagueSlug?: string;
  router: any;
}

class TheScoreSmallArticleCard extends React.Component<Props> {
  static defaultProps = {
    imageAltText: '',
    imageURL: null,
    onClick: null,
    styleOverrides: null,
    leagueSlug: null,
  };

  render() {
    return (
      <TheScoreSmallArticleContentCardItem
        imageAltText={this.props.imageAltText}
        imageURL={this.props.imageURL}
        text={this.props.text}
        publishedAt={this.props.publishedAt}
        leagueSlug={
          this.props.router.asPath === '/' ||
          this.props.router.asPath === '/top_news' ||
          this.props.router.asPath === '/trending'
            ? this.props.leagueSlug
            : null
        }
        styleOverrides={this.props.styleOverrides}
        uri={this.props.webUri}
      />
    );
  }
}

export default withRouter(TheScoreSmallArticleCard);
